import React from "react";
import Slider from "react-slick";
import { parsal_img } from "../../../assets/mediaCall";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Work = () => {
  const Work = [
    {
      image: parsal_img.work1,
      step: "Step 1",
      title: "Place your Order",
      description:
        "Select from a variety of shipping options to suit your needs.",
    },
    {
      image: parsal_img.work2,
      step: "Step 2",
      title: "Package & Prepare",
      description: "Securely pack your items, and we’ll handle the rest.",
    },
    {
      image: parsal_img.work3,
      step: "Step 3",
      title: "Track & Receive",
      description:
        "Stay informed with real-time tracking until your package arrives at its destination.",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-[#F7FAFF] py-20 inter">
      <div className="w-[82vw] xxl:w-[85vw] mlg:w-[92vw] smp:w-[96vw] mx-auto">
        <h2 className="font-semibold sm:text-[14px] inter text-[#6D6D6D] text-center">
          HOW IT WORKS
        </h2>
        <h2 className="font-extrabold inter text-center text-[30px] sm:text-2xl text-[#000000] leading-[36px] mt-2 mb-8">
          Effortless Shipping in <br />
          Three Steps
        </h2>

        {/* <Slider {...settings} className="p-5">
          {Work.map((item, index) => (
            <div className="px-5">
            <div
              key={index}
              className="inter bg-white rounded-xl shadow-md p-5 mx-2"
            >
              <div className="rounded-lg mb-5 flex items-center justify-center">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover rounded-lg"
                />
              </div>
              <h4 className="text-[14px] font-semibold text-[#3D40D1] mt-2">{item.step}</h4>
              <h3 className="text-[20px] font-bold text-[#232323] mt-2">{item.title}</h3>
              <p className="text-[14px] font-normal text-[#777777] mt-2">{item.description}</p>
            </div>
            </div>
          ))}
        </Slider> */}

        <Slider {...settings} className="overflow-hidden mt-2">
          {Work.map((item, index) => (
            <div
              key={index}
              className="w-full px-5 rounded-3xl"
              style={{ boxShadow: "0px 38px 60px 0px #0000000F" }}
            >
              <div className="inter bg-white rounded-xl p-5">
                <div className="rounded-lg mb-5 flex items-center justify-center overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="object-cover rounded-lg w-full"
                  />
                </div>
                <h4 className="text-[14px] font-semibold text-[#3D40D1] mt-2">
                  {item.step}
                </h4>
                <h3 className="text-[20px] font-bold text-[#232323] mt-2">
                  {item.title}
                </h3>
                <p className="text-[14px] font-normal text-[#777777] mt-2 line-clamp-1">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Work;
